
// src/utils/instagramApi.ts
import { InstagramApiResponse } from '@/types/instagram';

const API_BASE = (import.meta.env.VITE_API_URL as string) || '/api';

export const fetchInstagramPosts = async (): Promise<InstagramApiResponse> => {
  try {
    const response = await fetch(`${API_BASE}/instagram/posts`, {
      method: 'GET',
      headers: { 'Accept': 'application/json' },
      signal: AbortSignal.timeout(10000),
    });
    
    if (!response.ok) {
      throw new Error(`Erro HTTP Instagram API: ${response.status} - ${response.statusText}`);
    }
    
    const data: InstagramApiResponse = await response.json();

    if (!data.success) {
      throw new Error(data.error || 'API Instagram retornou success: false');
    }

    if (!data.posts || !Array.isArray(data.posts)) {
      throw new Error('Posts do Instagram não encontrados na resposta da API');
    }

    return data;
    
  } catch (err) {
    if (err instanceof Error) {
      if (err.name === 'AbortError' || err.name === 'TimeoutError') {
        throw new Error('Timeout: API Instagram demorou para responder');
      }
      throw err;
    }
    throw new Error('Erro desconhecido ao buscar posts do Instagram');
  }
};

// Função auxiliar para testar conectividade
export const testApiConnection = async (): Promise<boolean> => {
  try {
    const API_URL = getApiUrl();
    console.log('🔍 Testando conexão Instagram com:', API_URL);
    
    const response = await fetch(`${API_URL}/health`, {
      method: 'GET',
      signal: AbortSignal.timeout(10000)
    });
    
    const isHealthy = response.ok;
    console.log(isHealthy ? '✅ API Instagram saudável' : '⚠️ API Instagram com problemas');
    return isHealthy;
  } catch (err) {
    console.error('❌ Falha no teste de conexão Instagram:', err);
    return false;
  }
};

// Função para obter informações da API
export const getApiInfo = async () => {
  try {
    const API_URL = getApiUrl();
    const response = await fetch(`${API_URL}/api/info`, {
      signal: AbortSignal.timeout(5000)
    });
    
    if (response.ok) {
      const info = await response.json();
      console.log('ℹ️ Info da API Instagram:', info);
      return info;
    }
    return null;
  } catch (err) {
    console.error('❌ Erro ao obter info da API Instagram:', err);
    return null;
  }
};

// Função para forçar refresh da API
export const forceRefreshPosts = async (): Promise<InstagramApiResponse> => {
  const API_URL = getApiUrl();
  
  console.log('🔄 Forçando refresh na API Instagram...');
  
  try {
    const response = await fetch(`${API_URL}/api/instagram/refresh`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      signal: AbortSignal.timeout(45000) // Refresh pode demorar mais
    });
    
    if (!response.ok) {
      throw new Error(`Erro no refresh Instagram: ${response.status}`);
    }
    
    const data: InstagramApiResponse = await response.json();
    console.log('✅ Refresh Instagram concluído:', data);
    
    return data;
  } catch (err) {
    console.error('❌ Erro no refresh Instagram:', err);
    throw err;
  }
};
